module.exports = "<div class=\"main-content\" id=\"base-div\">\n    <!-- <i class=\"fa fa-wifi Online\" tooltip=\"You Are Online\" *ngIf=\"OnlineStatus\" aria-hidden=\"true\"></i>\n        <i class=\"fa fa-wifi Offline\" tooltip=\"You Are Offline\" *ngIf=\"!OnlineStatus\" aria-hidden=\"true\"></i> -->\n\n    <toaster-container [toasterconfig]=\"toastConfig\"></toaster-container>\n    <router-outlet></router-outlet>\n    <app-chatbot *ngIf=\"showChatbot\"></app-chatbot>\n</div> "


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src2505023020/src/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main